import { trackClientEvent } from '../../../../../trackClientEvent';
export const eventKey = 'retailer_pos-pdp_inventory_tooltip-view';
/**
 * User viewed the POS inventory tooltip for a given product option on the PDP
 */
export function trackRetailerPosPdpInventoryTooltipView(productOptionToken = '') {
    return trackClientEvent({
        eventKey,
        realTimeTracking: false,
        parameters: { productOptionToken },
    });
}
